import { useEffect } from 'react';
import { useModalContext } from 'src/hooks/useModalContext';

export const useCloseModalOnBackForward = () => {
  const { closeModal, openedModalName } = useModalContext();

  const handleEvent = (event: PageTransitionEvent) => {
    if (event.persisted) {
      if (openedModalName === 'DEPOSIT' || openedModalName === 'FORM_FIELDS') {
        closeModal();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('pageshow', handleEvent);
    return () => window.removeEventListener('pageshow', handleEvent);
  }, [openedModalName]);
};
